import { TranslateService } from '@ngx-translate/core';
import { takeWhile } from 'rxjs/operators';
import {
  Component,
  ChangeDetectionStrategy,
  OnDestroy,
  OnInit,
  ChangeDetectorRef,
  Input,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { MapObjectApiType, MapObject } from '../../../../../models';
import * as _ from 'lodash';
import { PolygonTopologyService } from '../../../../../services';
import { ToastrService } from 'ngx-toastr';
import { RangeFromParcelsButtonBaseComponent } from '../range-from-parcels-button-base.component';

@Component({
  selector: 'gk-range-from-all-parcels-button',
  templateUrl: './range-from-all-parcels-button.component.html',
  providers: [PolygonTopologyService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RangeFromAllParcelsButtonComponent
  extends RangeFromParcelsButtonBaseComponent
  implements OnDestroy, OnInit
{
  @ViewChild('buttonTemplate') buttonTemplate: TemplateRef<any>;
  @Input() buttonClass: string;
  noParcelsTranslation: string;
  successRangeAdditionTranslation: string;
  constructor(
    public override polygonTopologyService: PolygonTopologyService,
    public override toastr: ToastrService,
    protected translateService: TranslateService,
    public override changeDetectorRef: ChangeDetectorRef,
  ) {
    super(polygonTopologyService, toastr, changeDetectorRef);
  }

  ngOnInit(): void {
    this.fetchSuccessRangeAdditionNotificationText();
    this.fetchNoParcelsNotificationText();
  }

  fetchNoParcelsNotificationText(): void {
    this.translateService
      .get('GK.MAP.SELECT_PARCELS_FROM_MAP')
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((translation) => (this.noParcelsTranslation = translation));
  }

  fetchSuccessRangeAdditionNotificationText(): void {
    this.translateService
      .get('GK.MAP.SUCCESS_RANGE_ALL_PARCELS_ADDITION')
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(
        (translation) => (this.successRangeAdditionTranslation = translation),
      );
  }

  getParcels(): MapObject[] {
    return this.mapState.mapObjectTablesState.length === 1
      ? this.mapState.mapObjectTablesState[0].mapObjects.filter(
          (mapObject) => mapObject.type === MapObjectApiType.LandParcel,
        )
      : this.mapState.mapObjectTablesState.find(
          (mapObjectTableState) =>
            _.isEmpty(mapObjectTableState.mapObjectTypes) ||
            mapObjectTableState.mapObjectTypes.includes(
              MapObjectApiType.LandParcel,
            ),
        ).mapObjects;
  }
}
